export const addCentsToPrice = (price, cents) => {
  if (!price) {
    return null
  }
  return { priceCents: price.priceCents + (cents || 0), currency: price.currency }
}

export const subtractPrices = (priceA, priceB) => {
  return { priceCents: priceA.priceCents - priceB.priceCents, currency: priceA.currency }
}
